// REACT IMPORTS
import React, { useState, useEffect } from "react";

// CONTROLS IMPORTS
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema'
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { esES, enUS } from '@mui/x-data-grid/locales';
import { Box, TextField, Menu, MenuItem, Divider, IconButton, Grid,
    FormControl, InputLabel, Select, Typography, Button, Checkbox
 } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'; 

// ICONS IMPORTS

// REDUX IMPORTS
import { useDispatch, useSelector } from 'react-redux';
import { loadReviews } from '../../store/thunks';
// import { selectItem, showUserModal } from '../../store/slices';

// LANGUAGE IMPORTS
import { useTranslation } from 'react-i18next';

// OWNED COMPONENTS IMPORTS
import { constants } from  '../../util'
import BodyMain from "../../components/util/BodyMain";




const ReviewsReport = () => {
    // TRANSLATIONS
    const [t, i18n] = useTranslation("global");


    // LOCAL VARIABLES
    const columsGrid = 
    [
        {
            field: 'type',
            description: t("reviewsReport.type"),
            headerName: t("reviewsReport.type"),
            type: 'string',
            width: 80,
            headerAlign: 'left',
             renderCell: (params) => (
                <div>
                    {
                        language==='es' && params.row.type==='Album' 
                            ? 'Álbum'
                            : language==='es' && params.row.type==='Song' 
                                ? 'Canción'
                                : language==='en' && params.row.type==='Álbum' 
                                    ? 'Album'
                                    : language==='en' && params.row.type==='Canción' 
                                        ? 'Song'
                                        : params.value
                    }
                </div>
             )
        },
        {
            field: 'albumName',
            description: t("reviewsReport.albumName"),
            headerName: t("reviewsReport.albumName"),
            type: 'string',
            width: 200,
            headerAlign: 'left',
        },
        {
            field: 'artistName',
            description: t("reviewsReport.artistName"),
            headerName: t("reviewsReport.artistName"),
            type: 'string',
            width: 130,
            headerAlign: 'left',
        },
        {
            field: 'reviewer',
            description: t("reviewsReport.reviewer"),
            headerName: t("reviewsReport.reviewer"),
            type: 'string',
            width: 130,
            headerAlign: 'left',
        },
        {
            field: 'decisionDate',
            description: t("reviewsReport.decisionDate"),
            headerName: t("reviewsReport.decisionDate"),
            type: 'string',
            width: 130,
            headerAlign: 'left',
        },
        {
            field: 'statusName',
            description: t("reviewsReport.status"),
            headerName: t("reviewsReport.status"),
            type: 'string',
            width: 130,
            headerAlign: 'left',
            renderCell: (params) => (
                <div style={{width:'100%', height:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <div style={{
                        backgroundColor: params.row.statusColor==='yellow' ? '#FFFB95' : ( params.row.statusColor==='green' ? '#95FFA6' : ( params.row.statusColor==='blue' ? '#DDE6FF' : '#FFC7C7')),
                        border: params.row.statusColor==='yellow' ? '1px solid #CBA600' : ( params.row.statusColor==='green' ? '1px solid #009C17' : ( params.row.statusColor==='blue' ? '1px solid #0136BD' : '1px solid #C00000')),
                        width:'90%',
                        height:'30px',
                        display:'flex',
                        justifyContent:'center',
                        alignContent:'center',
                        alignItems:'center',
                        borderRadius:'7px',
                        color: '#667', 
                        fontSize: '0.7rem',
                        fontWeight: 'bold',
                    }}>
                        {
                            language==='es' && params.value==='Pending' 
                                ? "Pendiente"
                                : language==='es' && params.value==='Approved' 
                                    ? "Aprobado"
                                    : language==='es' && params.value==='Rejected' 
                                        ? "Rechazado"
                                        : language==='es' && params.value==='Published' 
                                            ? "Publicado"
                                            : language==='en' && params.value==="Pendiente" 
                                                ? "Pending"
                                                : language==='en' && params.value==='Aprobado' 
                                                    ? "Approved"
                                                    : language==='en' && params.value==='Rechazado' 
                                                        ? "Rejected"
                                                        : language==='en' && params.value==='Publicado' 
                                                            ? "Published"
                                                            : params.value
                        }
                    </div>
                </div>
            )
        },
    ];


    const sch = (yup) => yup.object({
        startDate: yup.string().required(),
        endDate: yup.string().required(),
        albumName: yup.string().max(30),
        artistName: yup.string().max(30),
        reviewer: yup.string().max(30),
        status: yup.string().max(20),
    });
    const schema = useYupSchema(sch);


    const { control, register, handleSubmit, reset, setFocus, getValues, setValue, formState: { errors: errors } } = useForm({
            resolver: yupResolver(schema),
            defaultValues: {
                startDate: dayjs().subtract(1, 'month').toISOString(),
                endDate: dayjs().toISOString(),
                albumName: '',
                artistName: '',
                reviewer: '',
                status: '-1'
            }
        });

    
    // LOCAL STATES
    
    // NEEDED HOOKS
    const dispatch = useDispatch();
    const { itemsReviews } = useSelector(state => state.reviews);
    const { language, deviceType } = useSelector(state => state.configuration);

    // EFFECTS
    useEffect(() => {
        dispatch(
            loadReviews
            (
                {
                    startDate: dayjs().subtract(1, 'month').toISOString(),
                    endDate: dayjs().toISOString(),
                    albumName: '',
                    artistName: '',
                    reviewer: '',
                    status: '-1'
                }
            )
        )
    }, [])

    // LOCAL FUNCTIONS
    const onSubmit = (data) => {
        dispatch(
            loadReviews
            (
                {
                    startDate: data.startDate,
                    endDate: data.endDate,
                    albumName: data.albumName,
                    artistName: data.artistName,
                    reviewer: data.reviewer,
                    status: data.status.toString()
                }
            )
        )
    }

    
    return (
        <>
            <BodyMain>
                <h2 style={{color:'#667'}}>{t("reviewsReport.title")}</h2>
                <form onSubmit={handleSubmit(onSubmit)}
                    style={{
                        width:'100%',
                        height:'100%',
                        display:'flex',
                        flexDirection:'column',
                        marginBottom:'50px'
                    }}
                >
                    <Grid container spacing={2} direction="row" size={12}>
                        <Grid container direction="row" size={12}>
                            <Grid size={6}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker']}>
                                        <Controller
                                            name="startDate"
                                            control={control}
                                            render={({ field, fieldState: { error } }) => (
                                                <DatePicker
                                                    label={t("reviewsReport.startDate")}
                                                    format="DD/MM/YYYY"
                                                    value={field.value ? dayjs(field.value) : null}
                                                    onChange={(date) => field.onChange(date)}
                                                    slotProps={{
                                                        textField: {
                                                            error: !!error,
                                                            helperText: error?.message,
                                                            margin: 'normal',
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Grid>
                            <Grid size={6}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker']}>
                                        <Controller
                                            name="endDate"
                                            control={control}
                                            render={({ field, fieldState: { error } }) => (
                                                <DatePicker
                                                label={t("reviewsReport.endDate")}
                                                format="DD/MM/YYYY"
                                                value={field.value ? dayjs(field.value) : null}
                                                onChange={(date) => field.onChange(date)}
                                                slotProps={{
                                                    textField: {
                                                    error: !!error,
                                                    helperText: error?.message,
                                                    },
                                                }}
                                                />
                                            )}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Grid>
                            <Grid size={6} sx={{paddingTop:'8px'}}>
                                <TextField label={t("reviewsReport.albumName")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield}} 
                                    {...register('albumName')}
                                    error={!!errors.albumName}
                                    helperText={errors.albumName?.message}
                                />
                            </Grid>
                            <Grid size={6} sx={{paddingTop:'8px'}}>
                                <TextField label={t("reviewsReport.reviewer")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield}} 
                                    {...register('reviewer')}
                                    error={!!errors.reviewer}
                                    helperText={errors.reviewer?.message}
                                />
                            </Grid>
                        {/* </Grid>
                        <Grid container spacing={2} direction="row" size={12}> */}
                            
                            <Grid size={6} sx={{paddingTop:'8px'}}>
                                <TextField label={t("reviewsReport.artistName")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield,}} 
                                    {...register('artistName')}
                                    error={!!errors.artistName}
                                    helperText={errors.artistName?.message}
                                />
                            </Grid>
                            <Grid size={6} sx={{paddingTop:'8px'}}>
                                <Controller
                                    name="status"
                                    control={control}
                                    render={({ field }) => (
                                    <FormControl fullWidth error={!!errors.statusId}>
                                        <InputLabel id="status-label">{t("reviewsReport.status")}</InputLabel>
                                        <Select
                                            {...field}
                                            labelId="status-label"
                                            label={t("reviewsReport.filterStatus")}
                                            sx={{ width: '100%' }}
                                        >
                                            <MenuItem value={-1}>
                                                <Typography>{ language==='es' ? 'Todos los estatus' : 'All status'}</Typography>
                                            </MenuItem>
                                            {/* <MenuItem value={905}>
                                                <Typography>{ language==='es' ? 'Publicado' : 'Published'}</Typography>
                                            </MenuItem> */}
                                            <MenuItem value={910}>
                                                <Typography>{ language==='es' ? 'Aprobado' : 'Approved'}</Typography>
                                            </MenuItem>
                                            <MenuItem value={930}>
                                                <Typography>{ language==='es' ? 'Rechazado' : 'Rejected'}</Typography>
                                            </MenuItem>
                                        </Select>
                                        {/* <FormHelperText>
                                            {errors.statusId?.message}
                                        </FormHelperText> */}
                                    </FormControl>
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} direction="row" size={12}>
                            <Grid size={6}>
                                <Button
                                    type="submit"
                                    variant="outlined"
                                    sx={{ ...constants.styles.mainButton, width: 'auto-fit', paddingLeft:'100px', paddingRight:'100px' }}
                                >
                                    {t("reviewsReport.search")}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
                <Box sx={{ 
                    width: '100%',
                    '& .alternateClass': {
                        backgroundColor: '#f2f2f2',
                        borderTop: '1px solid #e8e8e8',
                    },
                    '& .rowClass': {
                        borderTop: '1px solid #e8e8e8',
                    },
                    '& .alternateClass:hover': {
                        backgroundColor: '#999c9e',
                    },
                    '& .rowClass:hover': {
                        backgroundColor: '#999c9e',
                    },
                }}>
                    <DataGrid
                        getRowId={(row) => row.albumId}
                        getRowHeight={() => 40}
                        rows={itemsReviews || []}
                        columns={columsGrid}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10,
                                },
                            },
                            density: 'compact',
                        }}
                        // paginationModel={{ page: 0, pageSize: 100 }} // Muestra todas las filas
                        // pageSizeOptions={[]} // Oculta el selector de páginas
                        // hideFooter
                        getRowClassName ={
                            (params) =>
                                params.indexRelativeToCurrentPage % 2 === 0 ? 'alternateClass' : 'rowClass'
                        }
                        pageSizeOptions={[5,10,20,{value:-1, label:language==='es' ? 'Todo' : 'All'}]}
                        checkboxSelection = {false}
                        disableRowSelectionOnClick
                        disableColumnMenu
                        slots={{
                            toolbar: GridToolbar,
                        }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                            }
                        }}
                        localeText={
                            language === 'es' 
                            ? esES.components.MuiDataGrid.defaultProps.localeText
                            : enUS.components.MuiDataGrid.defaultProps.localeText
                        }
                        sx={{
                            '& .MuiDataGrid-cell, .MuiDataGrid-columnHeader': {
                                color: '#667', 
                                fontSize: '0.8rem',
                            },
                        }}
                    />
                </Box>
            </BodyMain>
        </>
    )
}

export default ReviewsReport;